import type { labelProviderInterface } from '../components/LabelProviderInterface';

export default function (context, facets) {
    const labelProvider: labelProviderInterface = (a, b) => (context as any).labelProvider(a, b); //eslint-disable-line

    const labelFallbacks = {
	    'products.facet.categories.categories': 'Categories',
      'products.facet.ranges.ranges': 'Ranges',
      'products.facet.subcategories.subcategories': 'Subcategories',
    };

    const getFieldName = (label) => {
        return labelProvider(label, labelFallbacks[label]);
    };

    return facets.map(facet => {
        if (facet.fieldName?.toLowerCase() === 'subcategory') {
          facet.displayName = getFieldName('products.facet.subcategories.subcategories');
        }
        if (facet.fieldName?.toLowerCase() === 'cat') {
          facet.displayName = getFieldName('products.facet.categories.categories');
        }
        if (facet.fieldName?.toLowerCase() === 'range') {
          facet.displayName = getFieldName('products.facet.ranges.ranges');
        }
        return facet;
    });
}
